<template>
	<div class="main-container">
		<rate-component
			:selected-subsidiary="subsidiaryId"
			:read-only="readOnly"
			:alreadyExistRate="customerWhithRate"
			:rates="rates"
			@rate-selected="rateSelected"
			@subsidiary-select="roomSubsidiaryModal"
		/>
	</div>
</template>
<script>
import rateComponent from '@/clerkinn/customers/subComponents/Rate-component';

function rateSelected(roomData) {
	this.$emit('update-customer-rate', roomData);
}

function roomSubsidiaryModal(value) {
	this.$emit('subsidiary-select', value);
}

function data() {
	return {
		readOnly: true,
	};
}

export default {
	name: 'rate-modal',
	components: {
		rateComponent,
	},
	data,
	methods: {
		rateSelected,
		roomSubsidiaryModal,
	},
	props: {
		customerWhithRate: {
			default: false,
			type: Boolean,
		},
		rates: {
			default: () => {},
			type: Object,
		},
		subsidiaryId: {
			default: null,
			type: Number,
		},
	},
};
</script>

<style lang="scss" scoped>
	.main-container {
		background-color: map-get($colors, disabled-habs);
		border-radius: 6px;
		padding: 15px;
	}

	.main-container::after {
		border-color: transparent;
		border-style: solid solid outset;
		border-top-color: map-get($colors, disabled-habs);
		border-width: 8px;
		bottom: -16px;
		content: " ";
		display: block;
		height: 0;
		position: absolute;
		right: 16px;
		width: 0;
	}
</style>



// WEBPACK FOOTER //
// RateModal.vue?5781312e